<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Nuevo grupo</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <h6>Captura la información del nuevo grupo:</h6>
    <form autocomplete="off" [formGroup]="formUser" (ngSubmit)="ruSure()" class="mt-3" id="userForm">
        <small>Todos los campos son obligatorios *</small>
        <div class="row mt-2">
            <div class="col-sm-12">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nombre del grupo</mat-label>
                    <input matInput formControlName="nombre" maxlength="45">
                    <mat-icon matSuffix>group</mat-icon>
                </mat-form-field>
            </div>

        </div>
        <div class="row mt-2">
            <div class="col-sm-12">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Selecciona perfil</mat-label>
                    <mat-select formControlName="tipo" (selectionChange)="getPermissions(); ">
                        <mat-option *ngFor="let rol of rolesList" [value]="rol.id">{{rol.rol}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>
        <div class="row mt-2">
            <div class="col-sm-12">
                <!--<mat-form-field class="w-100" appearance="outline">
                    <mat-label>Permisos</mat-label>
                    <mat-select formControlName="permissions" multiple>
                        <mat-option *ngFor="let p of permissionList" [value]="p.id">{{p.name}}</mat-option>
                    </mat-select>
                </mat-form-field>-->

                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Permisos</mat-label>
                    <mat-select formControlName="permissions" multiple>
                        <button  mat-flat-button (click)="toggleSelectAllPermissions()"><mat-icon>library_add</mat-icon>Seleccionar/declinar todos los permisos</button>
                        <ng-container  *ngFor="let m of modulesList" >
                            <mat-optgroup *ngIf="getPermbyModule(m.id).length != 0" [label]="''">
                                <div class="optgroup-header">
                                    <span>Permisos del módulo {{ m.nombre }}</span>
                                    <mat-checkbox (change)="toggleSelectAllByModule(m.id, $event.checked)"
                                      [checked]="isModuleFullySelected(m.id)"
                                      [indeterminate]="isModulePartiallySelected(m.id)">
                                    </mat-checkbox>
                                  </div>
                                <mat-option  *ngFor="let p of getPermbyModule(m.id)"  [value]="p.id">{{p.name}}</mat-option>                              
                            </mat-optgroup>
                          </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>


    </form>
</div>
<div class="modal-footer">
    <button mat-flat-button (click)="resetForm()">Limpiar <mat-icon>delete_outline</mat-icon></button>
    <button mat-flat-button class="bg-success text-white" form="userForm" type="submit">Guardar <mat-icon>save</mat-icon></button>
</div>